const modalCrearAlerta = {
  'Crear alerta de nuevos trabajos': 'Crear alerta de nuevos trabajos',
}

export default modalCrearAlerta
